import DynamicFormSettingsModelBase from '../_generated/modelBases/dynamic-form-settings-model-base';

export default class DynamicFormSettingsModel extends DynamicFormSettingsModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
